// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import billAuthorEntity from './entities/bill-author.json';
import billAuthorMenu from '../pages/bill-author/menu.json';
import billAuthorFullForm from '../pages/bill-author/forms/full.json';
import billAuthorContextForm from '../pages/bill-author/forms/context.json';
import billAuthorMiniForm from '../pages/bill-author/forms/mini.json';
import billAuthorLookupForm from '../pages/bill-author/forms/lookup.json';
import billAuthorTableView from '../pages/bill-author/views/table.json';
import billAuthorCardsView from '../pages/bill-author/views/cards.json';
import billAuthorCalendarView from '../pages/bill-author/views/calendar.json';
import billAuthorDashboardView from '../pages/bill-author/views/dashboard.json';

/** Тип запису «Автор законопроєкту» зі сторінками пакета: меню, форми та подання з pages/bill-author/. */
export const billAuthorDefinition: IRecordTypeDefinition = {
  ...billAuthorEntity,
  views: assembleViewSet({
      table: billAuthorTableView,
      cards: billAuthorCardsView,
      calendar: billAuthorCalendarView,
      dashboard: billAuthorDashboardView,
  }),
  form: billAuthorFullForm,
  forms: { full: billAuthorFullForm, context: billAuthorContextForm, mini: billAuthorMiniForm, lookup: billAuthorLookupForm },
  menu: billAuthorMenu,
} as IRecordTypeDefinition;
